import { IQueryParams } from '@entities/employee/api/employee.types';
import { COMPANY_TAG, SINGLE_COMPANY_TAG, baseApi } from '@shared/api';
import { LOCAL_STORAGE_ACCESS_TOKEN_KEY } from '@shared/lib/contants';
import { CompaniesListDto, CompanyDTO, ICompany } from '../model/company.types';

const companyApi = baseApi.injectEndpoints({
  endpoints: build => ({
    getCompanyList: build.query<CompaniesListDto, IQueryParams>({
      query: params => ({
        url: '/companies',
        params,
        headers: {
          Authorization: `Bearer ${localStorage.getItem(LOCAL_STORAGE_ACCESS_TOKEN_KEY)}`,
        },
      }),
      providesTags: [COMPANY_TAG],
    }),

    createCompany: build.mutation<void, CompanyDTO>({
      query: body => ({
        url: '/companies',
        method: 'POST',
        body,
      }),
      invalidatesTags: [COMPANY_TAG],
    }),
    updateCompany: build.mutation<ICompany, { id: string; body: CompanyDTO }>({
      query: ({ id, body }) => ({
        url: `companies/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: [COMPANY_TAG, SINGLE_COMPANY_TAG],
    }),

    getCompany: build.query<ICompany, string>({
      query: id => ({
        url: `/companies/${id}`,
      }),
      providesTags: [SINGLE_COMPANY_TAG],
    }),
    updateCompanyStatus: build.mutation<void, { id: string; isActive: boolean }>({
      query: ({ id, isActive }) => ({
        url: `/companies/${id}/status`,
        method: 'PATCH',
        body: {
          isActive,
        },
      }),
      invalidatesTags: [COMPANY_TAG],
    }),
  }),
});

export const {
  useGetCompanyListQuery,
  useCreateCompanyMutation,
  useGetCompanyQuery,
  useUpdateCompanyStatusMutation,
  useUpdateCompanyMutation,
} = companyApi;
